<template>
  <b-card-code title="All Documents">
    <!-- <button
      v-if="this.$store.state.app.user.is_staff"
      type="button"
      class="btn ml-auto btn-primary m-1"
    >
       <router-link class="text-white" :to="'/cvd/add'">Add New</router-link>
    </button> -->
    <!-- Search Function -->
    <b-card-code class="bg-light-secondary mb-1" title="Search">
      <b-form inline style="display: inline-block; width: 100%">
        <div class="row" style="width: 100%; padding: 5px">
          <!-- <b-form-select
            class="ml-1"
            style="width: 25%"
            v-model="project_filter"
            :options="project_options"
          >
          </b-form-select> -->
          <v-select
            id="project_filter"
            class="ml-1"
            style="width: 40%; background-color: white"
            v-model="project_filter"
            label="text"
            :options="project_options"
            @search="fetchOptions"
            placeholder="Project Name"
            autocomplete
            @input="load(true)"
          />
          <b-form-input
            class="ml-1"
            style="width: 25%"
            id="port"
            v-model="type_filter"
            placeholder="Document Type"
          />
          <b-button
            style="width: 20%"
            class="ml-1"
            variant="primary"
            @click="load(true)"
          >
            Search
          </b-button>
        </div>
      </b-form>
    </b-card-code>
    <div class="clearfix ml-auto col-sm-3 mb-1">
      <b-form inline>
        <b-form-select
          class="mr-1"
          v-model="sort_order"
          :options="with_sort_order_options"
          @change="load(true)"
        >
        </b-form-select>
        &nbsp;
        <b-form-select
          v-model="sort_by"
          :options="with_sort_options"
          @change="load(true)"
        >
        </b-form-select>
      </b-form>
    </div>
    <!-- End of search form -->
    <b-table
      responsive
      id="cvdTable"
      :fields="fields"
      :items="items"
      :per-page="perPage"
    >
      <template #cell(index)="data">
        {{ data.index + 1 + perPage * (currentPage - 1) }}
      </template>
      <template #cell(doc_name)="data">
        <router-link :to="'/document/view/' + data.item.doc_id"> {{data.item.document_type | serviceTypeFilter }} <span :title="data.item.doc_name">{{ data.item.doc_name | truncate(25, '...') }}</span></router-link> &nbsp;
        <b-badge v-if="data.item.versions_count>0" variant="success">{{data.item.versions_count}} Versions Available</b-badge>
      </template>
      <template #cell(owners)="data">
        <b-badge
          class="mb-1 mr-1"
          variant="primary"
          v-for="owner in data.item.owners"
          :key="owner.o_id"
          >{{ owner.profile.first_name }} {{ owner.profile.last_name }}</b-badge
        >
      </template>
      <template #cell(created_at)="data">
        {{ data.item.created_at | formatdate }}
      </template>
      <template #cell(actions)="data">
        <button
          @click="download(data.item)"
          v-if="!downloading.includes(data.item.doc_id)"
          type="button"
          class="btn btn-primary btn-sm mr-1"
          style="position: relative"
          :ref="`download_${data.item.doc_id}`"
        >
          Download
        </button>
        <button
        
          v-else
          type="button"
          class="btn btn-secondary btn-sm mr-1"
          style="position: relative"
        >
          Download
        </button>
      </template>
    </b-table>

    <b-pagination-nav
      v-model="currentPage"
      :numberOfPages="total"
      :link-gen="linkGen"
      :total-rows="rows"
      :per-page="perPage"
      :align="pagination_pos"
      aria-controls="cvdTable"
      use-router
    />
  </b-card-code>
</template>

<script>
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import { BTable } from "bootstrap-vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import {
  BPagination,
  BPaginationNav,
  BButton,
  BDropdown,
  BDropdownItem,
  BDropdownDivider,
  BForm,
  BFormInput,
  BBadge,
  BFormSelect,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import moment from "moment";
export default {
  components: {
    BCardCode,
    BTable,
    BPagination,
    BPaginationNav,
    BButton,
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    BForm,
    BFormInput,
    BBadge,
    BFormSelect,
    vSelect,
  },
  data() {
    return {
      pagination_pos: "center",
      // Call orgaization API and return in this format
      items: [],
      currentPage: 1,
      perPage: 10,
      rows: 0,
      total: 1,
      fields: [
        // { key: "doc_id", label: "ID" },
        { key: "index", label: "#" },
        { key: "doc_name", label: "Document", thStyle: { width: "20%" }, },
        { key: "project_profile.project_name", label: "Project" },
        { key: "owners", label: "Shared with" },
        { key: "added_by", label: "Added By" },
        { key: "created_at", label: "Uploaded At" },
        { key: "actions", label: "Actions" },
      ],
      project_filter: { value: "", text: "--Select--" },
      type_filter: "",
      project_options: [{ value: null, text: "Select Project" }],
      project_id: null,
      sort_by: null,
      with_sort_options: [
        { value: null, text: "--Sort By--" },
        { value: "doc_name", text: "Name" },
      ],
      sort_order: 1,
      with_sort_order_options: [
        { value: 1, text: "Ascending" },
        { value: 2, text: "Descending" },
      ],
      downloading: [],
    };
  },
  watch: {
    currentPage: function (newVal, oldVal) {
      this.load();
    },
    project_id: function (newVal, oldVal) {
      if (newVal != null) {
        console.log("changed");
        this.project_filter.value = newVal;
        this.project_filter.text = this.$route.query.project_name;
        this.load(true);
      }
    },
  },
  created: function () {
    if (this.$route.query.project_id)
      // alert(self.$route.query.project_id)
      this.project_id = parseInt(this.$route.query.project_id);
    else this.load();
  },
  filters: {
    formatdate: function (value) {
      if (value) {
        return moment(String(value)).format("DD-MM-YYYY hh:mm A");
      }
    },
    serviceTypeFilter: function (value) {
      if (value) {
        if(value == "Proxy for Old projects")
          return " "
        //if(value.includes("Offshore")){
        else{
          const service_name_splitted = value.split("-");
          let service_name = service_name_splitted[0];
          return service_name +" /";
        }
      }
    },
  },
  methods: {
    linkGen: function (pageNum) {
      return this.$router.currentRoute.path + "?page=" + pageNum;
    },
    loadProjectOptions() {
      if (this.$route.query.project_id)
        // alert(self.$route.query.project_id)
        this.project_id = parseInt(this.$route.query.project_id);
    },
    fetchOptions: function (search, loading) {
      if (search.length >= 2) {
        this.project_options = [];
        let url =
          process.env.VUE_APP_BASEURL +
          "client/project/projects?query=true&name=" +
          search;
        const options = {
          method: "GET",
          headers: { "content-type": "application/json" },
          url: url,
        };
        var self = this;
        this.$http(options).then((res) => {
          console.log(res.data);
          // this.toastMessage(res)  // method call to method2
          // this.items = res.data.results;
          res.data.results.map(function (value, key) {
            let pro = {
              value: res.data.results[key].project_id,
              text: res.data.results[key].project_name,
            };
            // console.log(res.data[key].profile.organization)
            self.project_options.push(pro);
          });
          if (self.$route.query.project_id)
            // alert(self.$route.query.project_id)
            self.project_id = parseInt(self.$route.query.project_id);
        });
      }
    },
    load: function (search = false) {
      let url = process.env.VUE_APP_BASEURL + "client/project/docs?query=true&list_type=main";
      if (this.$route.query.page && !search) {
        this.currentPage = this.$route.query.page;
        url = url + "&page=" + this.currentPage;
      }
      if (this.project_filter) {
        if (search)
          url = url + "&page=1&project_id=" + this.project_filter.value;
        else url = url + "&project_id=" + this.project_filter.value;
        // this.currentPage = 1;
      }
      if (this.type_filter != "") {
        url = url + "&doc_type=" + this.type_filter;
      }
      if (this.sort_by != null) {
        url =
          url + "&sort_by=" + this.sort_by + "&sort_order=" + this.sort_order;
      }
      const options = {
        method: "GET",
        headers: { "content-type": "application/json" },
        url: url,
      };
      this.$http(options).then((res) => {
        console.log(res.data);
        // this.toastMessage(res)  // method call to method2
        this.items = res.data.results;
        this.rows = res.data.length;
        this.total = Math.ceil(res.data.count / this.perPage);
        //   this.currentPage = 1
        //   this.perPage = 10
        //   this.rows = res.data.count
      });
    },
    download(item) {
      // extract extension and make filename
      let filepath = JSON.parse(item.doc_url);
      let ext = filepath.key.split("/")[1].split(".")[1];
      this.downloading.push(item.doc_id);
      console.log("Download in progress", this.downloading);
      // this.loading = true;
      const options = {
        method: "GET",
        url:
          process.env.VUE_APP_BASEURL +
          "client/project/docs/" +
          item.doc_id +
          "/download/",
        responseType: "blob",
      };
      var self = this;
      this.$http(options)
        .then((res) => {
          // this.loading = false;
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", item.doc_name + "." + ext); //or any other extension
          document.body.appendChild(link);
          link.click();
          this.downloading.pop(item.doc_id);
        })
        .catch(function (error) {
          alert("Error, please try agin");
          console.log(error.toJSON());
          this.downloading.pop(item.doc_id);
        });
    },
  },
};
</script>

